import { AtlasMapMarkerData, AtlasMarkerOptions } from "@asfinag/atlas/map";
import * as L from "leaflet";
import { LatLngExpression } from "leaflet";

import { MARKER_ICON_SIZE } from "../config/app.config";
import { DigitalEquipmentDto } from "../services/bbo-client.service";
import { Point } from "./point.model";

export const DIGITAL_EQUIPMENT_MARKERS_PANE = "digital-equipments";

export class DigitalEquipment implements AtlasMapMarkerData {
	assetId: string;
	assetIdNumber: number;
	assetName: string;
	location: Point;
	stationary: boolean;
	isAssigned: boolean;
	isLocationChanged: boolean;

	constructor(res: DigitalEquipmentDto) {
		this.assetId = res.assetId as string;
		this.assetIdNumber = parseInt(this.assetId.replace("-", ""), 10);
		this.assetName = res.assetName as string;
		this.location = new Point(res.lat as number, res.lon as number);
		this.stationary = res.stationary as boolean;
		this.isAssigned = !!res.isAssigned;
		this.isLocationChanged = !!res.isLocationChanged;
	}

	get MarkerLocation(): LatLngExpression {
		return [this.location.lat, this.location.lon];
	}

	get MarkerOptions(): AtlasMarkerOptions {
		const resultIfFinalPosition = this.isAssigned ? "digital-equipment-assigned" : "digital-equipment-unassigned";
		const resultIfLocationIsNotChanged = this.stationary ? resultIfFinalPosition : "digital-equipment-not-final";
		return {
			icon: this.createDivIcon(
				MARKER_ICON_SIZE,
				this.isLocationChanged ? "digital-equipment-changed-location" : resultIfLocationIsNotChanged,
			),
			pane: DIGITAL_EQUIPMENT_MARKERS_PANE,
		};
	}

	private createDivIcon(iconSize: number, className = ""): L.DivIcon {
		return L.divIcon({
			className,
			// 40.5 is the height of the equipment number div
			iconSize: [iconSize, iconSize],
			html: `
                <img class="place-icon" src="assets/icons/place.svg" height="${iconSize}px" width="${iconSize}px">`,
		});
	}

	public isEqual(other: DigitalEquipment): boolean {
		return (
			!!other &&
			this.assetId == other.assetId &&
			this.assetName == other.assetName &&
			this.stationary == other.stationary &&
			this.isLocationChanged == other.isLocationChanged &&
			this.isAssigned == other.isAssigned &&
			this.location.lat == other.location.lat &&
			this.location.lon == other.location.lon
		);
	}

	public copyWith(changeDigitalEquipment?: (digitalEquipment: DigitalEquipment) => void): DigitalEquipment {
		const result: DigitalEquipment = Object.create(this);
		if (changeDigitalEquipment) {
			changeDigitalEquipment(result);
		}
		return result;
	}
}
